import classNames from 'classnames';
import styles from './SocialLinks.module.scss';
import IconFacebook from 'ui/icons/icon_facebook.svg';
import IconTwitter from 'ui/icons/icon_twitter.svg';
import IconYouTube from 'ui/icons/icon_youtube.svg';
import IconInstagram from 'ui/icons/icon_instagram.svg';
import IconLinkedIn from 'ui/icons/icon_linkedin.svg';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface SocialLink {
	type?: 'Facebook' | 'Twitter' | 'YouTube' | 'Instagram' | 'LinkedIn';
	title: string;
	url: string;
}

export interface SocialLinksProps {
	className?: string;
	items?: SocialLink[];
	hide?: boolean;
}

export const UI_SocialLinks = ({ className, items, hide }: SocialLinksProps) => {
	if (!items) {
		return null;
	}

	const renderIcon = (item: SocialLink) => {
		switch (item.type) {
			case 'Facebook':
				return <IconFacebook aria-hidden="true" />;
			case 'Twitter':
				return <IconTwitter aria-hidden="true" />;
			case 'YouTube':
				return <IconYouTube aria-hidden="true" />;
			case 'Instagram':
				return <IconInstagram aria-hidden="true" />;
			case 'LinkedIn':
				return <IconLinkedIn aria-hidden="true" />;
		}
	};

	return (
		<ul className={classNames(styles.SocialLinks, className, { [styles.SocialLinks___hide]: hide })}>
			{items.map((item, index) => (
				<li key={index} className={styles.SocialLinks_item}>
					<UI_Link className={styles.SocialLinks_link} ariaLabel={item.title} {...item}>
						<UI_Icon className={styles.SocialLinks_icon} style="circle" size="lg">
							{renderIcon(item)}
						</UI_Icon>
					</UI_Link>
				</li>
			))}
		</ul>
	);
};
